import { css } from '@emotion/react';
import { ComponentPropsWithRef, useState } from 'react';

export const FadeInImage = (props: ComponentPropsWithRef<'img'>) => {
  const [className, setClassName] = useState('');

  return (
    <img
      alt=""
      css={styles.img}
      onLoad={() => {
        setClassName('fade-in');
      }}
      width="100%"
      height="auto"
      {...props}
      className={[className, props.className].join(' ')}
    />
  );
};

const styles = {
  img: css({
    opacity: 0,
    height: 'auto',
    maxWidth: '100%',

    '@keyframes fadein': { from: { opacity: 0 }, to: { opacity: 1 } },
    '&.fade-in': { animation: 'fadein 0.35s ease forwards' }
  })
};
